import React from "react";
import styles from '../styles/betStatistics.module.scss'
import LoadingUI from "@/compoments/loadingUI";
import { useTranslation } from "react-i18next";

const BetStatistics = ({data}) => {
  const { t } = useTranslation('record')
  const items = [
    {
      title: t('totalBetting'),
      content: `${data?.totalLine?.countId}单`
    },
    {
      title: t('betAmountRmb'),
      content: data?.totalLine?.validBetAmount
    },
    {
      title: t('winLossRmb'),
      content: data?.totalLine?.netAmount
    },
  ]

  return(
    <div className={styles.BetStatistics}>
      {items.map((v,index)=>{
        return <div key={index} className={styles.item}>
          <div className={styles.title}>{v.title}</div>
          <div className={styles.content}>{v.content}</div>
        </div>
      })}
    </div>
  )
}

export default BetStatistics